<template>
    <div class="about">
        <p>{{this.messages}}</p>
    </div>
</template>

<script>
    export default({
        props:{
            "messages":{}
        }
    })
</script>

<style scoped>
    .about{
        padding-left: 10%;
        border-bottom-right-radius: 20px;
        border-bottom-left-radius: 20px;
        padding-bottom: 50px;
        background-image: url("../../public/report-background.jpg");
        background-size: 100% auto;
        background-repeat: no-repeat;
        background-color: #111111;

    }
    .about p {
        font-size: 13px;
        font-weight: bold;
    }

</style>